/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");
var jQuery = require("jquery");

'use strict';
module.exports = function (str) {
	return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
		return '%' + c.charCodeAt(0).toString(16).toUpperCase();
	});
};




//////////////////
// WEBPACK FOOTER
// ./node_modules/strict-uri-encode/index.js
// module id = 863
// module chunks = 76